var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 32",
    style: {
      enableBackground: "new 0 0 136 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,4c0,1-0.3,1.7-0.9,2.3c-0.7,0.7-1.5,1-2.6,1c-1,0-1.9-0.3-2.6-1c-0.7-0.7-1.1-1.5-1.1-2.5 c0-1,0.4-1.9,1.1-2.5c0.7-0.7,1.6-1,2.6-1c0.5,0,1,0.1,1.4,0.3c0.5,0.2,0.8,0.4,1.1,0.8L43,1.8C42.5,1.2,41.9,1,41.1,1 c-0.7,0-1.4,0.3-1.9,0.8c-0.5,0.5-0.8,1.2-0.8,2s0.3,1.5,0.8,2c0.5,0.5,1.2,0.8,1.9,0.8c0.8,0,1.4-0.3,2-0.8 c0.3-0.3,0.5-0.8,0.6-1.4h-2.5V3.4h3.4C44.5,3.6,44.5,3.8,44.5,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.9,1.1h-3.2v2.2h2.9v0.8h-2.9v2.2h3.2v0.8h-4.1V0.3h4.1V1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,7.1h-0.9v-6h-2V0.3h4.8v0.8h-2V7.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.1,7.1V0.3H60v6.8H59.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,7.1h-0.9v-6h-2V0.3H66v0.8h-2V7.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,6.2c-0.7,0.7-1.5,1-2.6,1c-1,0-1.9-0.3-2.6-1c-0.7-0.7-1-1.5-1-2.5s0.3-1.8,1-2.5c0.7-0.7,1.5-1,2.6-1 c1,0,1.9,0.3,2.6,1c0.7,0.7,1,1.5,1,2.5C76.1,4.7,75.8,5.5,75.1,6.2z M70.6,5.6c0.5,0.5,1.2,0.8,1.9,0.8c0.7,0,1.4-0.3,1.9-0.8 c0.5-0.5,0.8-1.2,0.8-2c0-0.8-0.3-1.5-0.8-2c-0.5-0.5-1.2-0.8-1.9-0.8c-0.8,0-1.4,0.3-1.9,0.8c-0.5,0.5-0.8,1.2-0.8,2 C69.8,4.5,70.1,5.1,70.6,5.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.4,7.1V0.3h1.1l3.4,5.3h0l0-1.3v-4h0.9v6.8h-0.9l-3.6-5.6h0l0,1.3v4.3H77.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,17.1c-2.7,0-5,2-5,4.8c0,2.8,2.2,4.8,5,4.8c2.7,0,5-2.1,5-4.8C73.7,19.1,71.4,17.1,68.7,17.1z M68.7,24.9 c-1.5,0-2.8-1.2-2.8-2.9c0-1.7,1.3-2.9,2.8-2.9s2.8,1.2,2.8,2.9C71.5,23.6,70.2,24.9,68.7,24.9z M57.8,17.1c-2.7,0-5,2-5,4.8 c0,2.8,2.2,4.8,5,4.8c2.7,0,5-2.1,5-4.8C62.8,19.1,60.6,17.1,57.8,17.1z M57.8,24.9c-1.5,0-2.8-1.2-2.8-2.9c0-1.7,1.3-2.9,2.8-2.9 c1.5,0,2.8,1.2,2.8,2.9C60.6,23.6,59.3,24.9,57.8,24.9z M44.9,18.6v2.1h5c-0.1,1.2-0.5,2-1.1,2.6c-0.7,0.7-1.9,1.5-3.9,1.5 c-3.1,0-5.5-2.4-5.5-5.5s2.4-5.5,5.5-5.5c1.7,0,2.9,0.6,3.8,1.5l1.5-1.5c-1.3-1.2-2.9-2.1-5.3-2.1c-4.3,0-7.8,3.4-7.8,7.5 s3.6,7.5,7.8,7.5c2.3,0,4-0.7,5.4-2.1c1.4-1.4,1.8-3.3,1.8-4.8c0-0.5,0-0.9-0.1-1.3H44.9z M97.8,20.2c-0.4-1.1-1.7-3.1-4.3-3.1 c-2.6,0-4.7,2-4.7,4.8c0,2.7,2.1,4.8,4.9,4.8c2.3,0,3.6-1.4,4.1-2.1l-1.7-1.1c-0.6,0.8-1.3,1.3-2.4,1.3c-1.1,0-1.9-0.5-2.4-1.5 l6.6-2.7L97.8,20.2z M91,21.8c-0.1-1.9,1.5-2.8,2.6-2.8c0.9,0,1.6,0.4,1.8,1L91,21.8z M85.6,26.5h2.2V12.2h-2.2V26.5z M82,18.2 L82,18.2c-0.6-0.6-1.5-1.1-2.7-1.1c-2.5,0-4.8,2.1-4.8,4.9c0,2.7,2.3,4.8,4.8,4.8c1.2,0,2.1-0.5,2.6-1.1H82v0.7c0,1.9-1,2.8-2.6,2.8 c-1.3,0-2.2-0.9-2.5-1.7L75,28.2c0.5,1.3,2,2.9,4.4,2.9c2.6,0,4.7-1.5,4.7-5v-8.7H82V18.2z M79.5,24.9c-1.5,0-2.8-1.2-2.8-2.9 c0-1.7,1.3-3,2.8-3c1.5,0,2.7,1.2,2.7,3C82.2,23.6,81,24.9,79.5,24.9z M108,12.2h-5.2v14.2h2.2v-5.4h3c2.4,0,4.8-1.7,4.8-4.4 C112.8,13.9,110.4,12.2,108,12.2z M108,19.1h-3.1v-4.9h3.1c1.6,0,2.6,1.3,2.6,2.4C110.6,17.8,109.7,19.1,108,19.1z M121.5,17 c-1.6,0-3.2,0.7-3.9,2.2l1.9,0.8c0.4-0.8,1.2-1,2-1c1.1,0,2.3,0.7,2.3,1.8V21c-0.4-0.2-1.2-0.6-2.3-0.6c-2.1,0-4.2,1.1-4.2,3.2 c0,1.9,1.7,3.1,3.6,3.1c1.5,0,2.3-0.6,2.8-1.4h0.1v1.1h2.1V21C125.9,18.5,124,17,121.5,17z M121.2,24.9c-0.7,0-1.7-0.3-1.7-1.2 c0-1.1,1.2-1.5,2.3-1.5c1,0,1.4,0.2,2,0.5C123.6,23.9,122.5,24.9,121.2,24.9z M133.6,17.4l-2.5,6.2H131l-2.6-6.2h-2.3L130,26 l-2.2,4.8h2.3l6-13.4H133.6z M114,26.5h2.2V12.2H114V26.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.6593,
    y1: 5.9193,
    x2: -5.4568,
    y2: 25.4986,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006599999,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,0.9C0.2,1.2,0,1.8,0,2.5v25.2c0,0.7,0.2,1.3,0.5,1.6l0.1,0.1l14.5-14.1v-0.3L0.5,0.9L0.5,0.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.8473,
    y1: 18.9245,
    x2: -0.3903,
    y2: 18.9245,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.9,19.9l-4.8-4.7v-0.3l4.8-4.7l0.1,0.1l5.7,3.2c1.6,0.9,1.6,2.4,0,3.3L20,19.9L19.9,19.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.6618,
    y1: 12.0953,
    x2: -18.2612,
    y2: 38.6464,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,19.9l-4.9-4.8L0.5,29.3C1.1,29.8,2,29.9,3,29.3L20,19.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.3031,
    y1: 5.3012,
    x2: -0.7273,
    y2: 17.1574,
    gradientTransform: "matrix(1 0 0 -1 0 34)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M20,10.3L3,0.8C2,0.3,1.1,0.3,0.5,0.9l14.5,14.2L20,10.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.d6cf5305085b8745f51fe7a9f4b30fd7.svg";
export { ForwardRef as ReactComponent };